import React from 'react';
import {
  Modal as ModalBootstrap,
  ModalProps as ModalBootstrapProps,
} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './style.css';

interface CustomModalProps extends ModalBootstrapProps {
  icone?: string;
  tituloModal?: string;
  open: boolean;
  onHide: () => void;
  children: React.ReactNode;
  clear?: boolean;
  style?: React.CSSProperties;
  modalHeight?: string | number;
  classSize?: string; // <-- Classe para definir a largura
}

function ModalTwo({
  icone,
  tituloModal,
  open,
  onHide,
  children,
  clear = false,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  style,
  modalHeight,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  classSize,
  ...props
}: CustomModalProps) {
  const ariaLabel = clear ? 'clear-modal' : 'informes-modal';

  return (
    <ModalBootstrap
      show={open}
      onHide={onHide}
      aria-labelledby={ariaLabel}
      centered
      dialogClassName="modal-90vw"
      {...props}
    >
      {!clear && (
        <ModalBootstrap.Header closeButton>
          <ModalBootstrap.Title
            id={ariaLabel}
            className="d-flex align-items-center fw-normal"
          >
            {icone && (
              <span className="material-icons" style={{ color: '#0a58ca' }}>
                {icone}
              </span>
            )}
            &nbsp;{tituloModal}
          </ModalBootstrap.Title>
        </ModalBootstrap.Header>
      )}
      <ModalBootstrap.Body
        style={{
          padding: '30px',
          ...(modalHeight ? { height: modalHeight, overflowY: 'auto' } : {}),
        }}
      >
        {children}
      </ModalBootstrap.Body>
    </ModalBootstrap>
  );
}

export default ModalTwo;
